import { render, staticRenderFns } from "./fqCertificate.vue?vue&type=template&id=02fc361c"
import script from "./fqCertificate.vue?vue&type=script&lang=js"
export * from "./fqCertificate.vue?vue&type=script&lang=js"
import style0 from "./fqCertificate.vue?vue&type=style&index=0&id=02fc361c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports